import React, { Component } from 'react';

import { ADMISSION_PRINT_COLUMNS, ALL_PRINT_COLUMN_KEYS } from '../utils/printAdmissions';

// Qué columnas imprimir. La elección se guarda en el navegador porque en la práctica cada
// local imprime siempre la misma hoja (la de puerta, sin mail ni fecha de compra): sin esto
// habría que destildar lo mismo antes de cada impresión.
const STORAGE_KEY = 'eventPrintColumns';

// El storage puede estar bloqueado (modo privado) o traer basura de una versión vieja, y
// romper acá dejaría la pantalla de anotados en blanco. Ante cualquier duda: todas.
function loadColumns() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return ALL_PRINT_COLUMN_KEYS.slice();
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return ALL_PRINT_COLUMN_KEYS.slice();
        // Se filtra contra las columnas que existen HOY: una key retirada del listado quedaría
        // guardada para siempre en el navegador del mostrador.
        const validas = parsed.filter((k) => ALL_PRINT_COLUMN_KEYS.indexOf(k) !== -1);
        return validas.length > 0 ? validas : ALL_PRINT_COLUMN_KEYS.slice();
    } catch (e) {
        return ALL_PRINT_COLUMN_KEYS.slice();
    }
}

function saveColumns(columns) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(columns));
    } catch (e) {
        // noop: no poder recordar la elección no es motivo para no imprimir
    }
}

// Paso previo a imprimir el listado de anotados: el checklist de columnas. Modal de Bootstrap,
// se abre con data-target="#modal-print-admissions" desde la grilla.
class ModalPrintAdmissionsComponent extends Component {
    constructor() {
        super();
        this.state = { columns: loadColumns() };
    }

    isChecked = (key) => this.state.columns.indexOf(key) !== -1;

    // El orden en que se tildan no importa: la hoja sale siempre en el orden de
    // ADMISSION_PRINT_COLUMNS (lo reordena buildAdmissionsPrintHtml).
    toggle = (key) => {
        const columns = this.isChecked(key)
            ? this.state.columns.filter((k) => k !== key)
            : this.state.columns.concat(key);
        this.setState({ columns });
    }

    setAll = (todas) => {
        this.setState({ columns: todas ? ALL_PRINT_COLUMN_KEYS.slice() : [] });
    }

    closeModal = () => {
        const closeButton = document.getElementById('modal-print-admissions-close');
        if (closeButton) {
            closeButton.click();
        }
    }

    onClickPrint = () => {
        saveColumns(this.state.columns);
        // Cerrar ANTES de imprimir: el diálogo de impresión congela la página, y con el modal
        // todavía abierto el operador vuelve a una pantalla tapada por el backdrop.
        this.closeModal();
        this.props.onPrint(this.state.columns);
    }

    render() {
        const sinColumnas = this.state.columns.length === 0;
        return (
            <div className="modal fade" id="modal-print-admissions" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Imprimir listado</h4>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="mb-0">Columnas a imprimir</label>
                                <div>
                                    <button type="button" className="btn btn-sm btn-white" onClick={() => this.setAll(true)}>Todas</button>
                                    <button type="button" className="btn btn-sm btn-white ml-1" onClick={() => this.setAll(false)}>Ninguna</button>
                                </div>
                            </div>
                            {ADMISSION_PRINT_COLUMNS.map((c) => (
                                <div className="form-group mb-1" key={c.key}>
                                    <label className="mb-0">
                                        <input type="checkbox" checked={this.isChecked(c.key)} onChange={() => this.toggle(c.key)} />
                                        &nbsp;{c.label}
                                    </label>
                                </div>
                            ))}
                            {sinColumnas && (
                                <small className="text-danger">Elegí al menos una columna.</small>
                            )}
                            {/* El filtro de estado NO se toca acá: se imprime la lista que está
                                en pantalla. Decirlo evita la sorpresa de imprimir "Impagas"
                                creyendo que sale el listado entero. */}
                            <small className="d-block text-muted mt-2">
                                {this.props.rowCount === 1
                                    ? 'Se imprime el único anotado que estás viendo'
                                    : `Se imprimen los ${this.props.rowCount} anotados que estás viendo`}
                                &nbsp;(filtro: {this.props.statusLabel}).
                            </small>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-accent" disabled={sinColumnas} onClick={this.onClickPrint}>
                                Imprimir
                            </button>
                            <button id="modal-print-admissions-close" type="button" className="btn btn-outline-secondary" data-dismiss="modal">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalPrintAdmissionsComponent;
